module.exports = __webpack_public_path__ + "img/circle-tick.7f330df0.svg";